module.exports = __webpack_public_path__ + "static/google-play-badge-c48d6a169d52473c6679a757b21580ec.png";